export const localStorageKeys = {
    USER_TOKEN: "user_token",
};
